module.exports = __webpack_public_path__ + "img/txt_to-official.e7d00480.png";